import React, { Component } from 'react';
import TaxAuthorityStep3Page from './tax-authority-step3-html';
class TaxAuthorityStep3 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TaxAuthorityStep3Page
                />
            </div>
        )
    }
}
export default TaxAuthorityStep3;